

export const apiPaths = {
    initiateResetPassword: 'send-reset-password-link',
    resetPassword: 'reset-password',
}